// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1ib37W2s","voucher-form":"_1nLbm-_q","content":"_1PRdJHFy","payment-button":"_38eVAgds","total-title":"_2JJ93KGn","details-container":"_2_pPJz3x","paypal":"OAXBNWja"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/SubscriptionSummary/SubscriptionSummary.styl
// module id = 521
// module chunks = 0